
















































































































































import {
  Component,
  Vue
} from "@/shared/vuepack";
import Logo from "@/shared/components/Logo.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import * as RouteNames from "@/employee/route-names";
import { FetchState } from "@/shared/types";
import { formatCurrency } from "@/shared/currency";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useUserStore } from "@/shared/store/user";
import { FeeWaiverType } from "@/admin/types";

@Component({
  components: {
    Logo,
    GenericLoadingSpinner
  }
})
export default class TermsFeeSchedule extends Vue {
  userStore = useUserStore();
  enrollmentStore = useEnrollmentStore();
  custodianSettingsStore = useCustodianSettingsStore();
  portalCustomizationStore = usePortalCustomizationStore();

  format = formatCurrency;

  get quarterlyStatementFee () {
    return `${formatCurrency(this.custodianSettingsStore.quarterlyPaperStatementFee)}`;
  }

  get monthlyAdminFee () {
    return `${formatCurrency(this.enrollmentStore.feeSchedule.monthlyFeeAmount)}`;
  }

  get scrollContents () {
    return this.$route.name !== RouteNames.FeeSchedulePrint;
  }

  get showLoadingSpinner () {
    return this.enrollmentStore.feeScheduleFetchState === FetchState.Loading ||
      !this.portalCustomizationStore.isSupportInfoLoaded;
  }

  get partnerName () {
    return this.portalCustomizationStore.supportInfo.displayName;
  }

  get showFeeWaiverDisclaimer () {
    return this.enrollmentStore.showWaiver
    && (this.userStore.isIndividualAccountType
    || this.enrollmentStore.feeSchedule.isEmployerBalanceFeeWaiverEnabled);
  }

  mounted () {
    this.enrollmentStore.loadFeeWaiverSettings(this.portalCustomizationStore.partnerId);
    this.enrollmentStore.loadFees();
    this.custodianSettingsStore.getCustodianSettings();
  }
}
